import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 20px;
    overflow: hidden;
    padding-left: -1px;
    width: 290px;
    height: 628px;
     box-sizing: border-box;         /* Opera/IE 8+ */
    -webkit-box-sizing: border-box; /* Safari/Chrome, other WebKit */
    -moz-box-sizing: border-box;    /* Firefox, other Gecko */
    @media (min-width: 768px) and (max-width: 1025px) {
        width: 211px;
        height: 456px;
    }
`;

export const ScrollableContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow-x: hidden;
    overflow-y: scroll;
    flex: 1;
    ::-webkit-scrollbar {
        width: 0px;
        background: transparent; /* make scrollbar transparent */
    }
    &>* {
         flex-shrink: 0;
    }
    @media (min-width: 768px) and (max-width: 1025px) {
        padding: 0 8px;
        &>* {
            flex: 1;
            flex-shrink: unset;
            width: 100%;
        }
    }
`;
